import type { Profile } from 'models';
import { message } from 'ui';
import { ProfileForm, ProfileFormSkeleton, type ProfileFormValues } from '../../../profile-form';
import { useEducationsLevel, useGenders, useInterests, useProfessions, useUpdateUserProfile } from '../../../queries';

type P = { onClose: () => void; viewer: Profile };

const EditProfileModalContent = ({ onClose, viewer }: P) => {
  const { data: genders } = useGenders();
  const { data: professions } = useProfessions();
  const { data: educationsLevel } = useEducationsLevel();
  const { data: interests } = useInterests();

  const { isPending: isLoading, mutate: updateProfile } = useUpdateUserProfile();

  const onSubmit = (values: ProfileFormValues) => {
    updateProfile(
      {
        userData: { ...values, coverPhoto: values.coverPhoto?.[0], profilePhoto: values.profilePhoto?.[0] },
        userId: viewer.id,
      },
      {
        onSuccess() {
          message.success('Profile has been successfully updated.');
          onClose();
        },
      },
    );
  };

  return (
    <>
      {!genders || !professions || !educationsLevel || !interests ? (
        <ProfileFormSkeleton />
      ) : (
        <ProfileForm
          educationLevels={educationsLevel}
          genders={genders}
          interests={interests}
          loading={isLoading}
          onCancel={onClose}
          onSubmit={onSubmit}
          professions={professions}
          user={viewer}
        />
      )}
    </>
  );
};

export default EditProfileModalContent;
